import { motion } from "framer-motion";
import { testimonials } from "../data/testimonials";
import { Quote, Linkedin } from "lucide-react";

export default function Testimonials() {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section data-testid="testimonials" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <div className="overline">Recommendations</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
            In their own words.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ backgroundColor: "var(--border-soft)" }}>
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              className="relative p-8 md:p-10"
              style={{ backgroundColor: "var(--bg)" }}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              whileHover={{ y: -3 }}
            >
              <Quote size={22} style={{ color: "var(--accent-strong)" }} className="mb-5" />
              <blockquote className="font-serif text-lg md:text-xl leading-snug" style={{ color: "var(--primary)" }}>
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5" style={{ borderTop: "1px solid var(--border-soft)" }}>
                <div className="font-semibold text-sm" style={{ color: "var(--text-primary)" }}>{t.name}</div>
                <div className="text-xs" style={{ color: "var(--text-secondary)" }}>
                  {t.role}{t.company && ` · ${t.company}`}
                </div>
                {t.linkedin && (
                  <a href={t.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[11px] mt-2 link-underline" style={{ color: "var(--accent-strong)" }}>
                    <Linkedin size={11} /> View on LinkedIn
                  </a>
                )}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
